import React, { memo } from 'react';
import './GroupNode.css';

function GroupNode({ data }) {
  return (
    <div className="group-node">
      <div className="group-node-header">
        {data.label || 'Group'}
      </div>
    </div>
  );
}

export default memo(GroupNode);
